module.exports = __webpack_public_path__ + "static/media/clock.09af84b3.svg";